import _ from 'lodash';
import FundInformation from '@/app/modules/fund/components/fund-information/fund-information.vue';
import ConfirmModal from '@/app/modules/toolkit/common/components/confirm-modal/confirm-modal.vue';
import ReviewItem from '@/app/modules/toolkit/common/components/review-item/review-item.vue';
import pdfContainer from '@/app/modules/pdf/containers/pdf-container.vue';
import { types } from '@/app/filters/filters';

export default {
  name: 'inv-strat-review-review',
  components: {
    FundInformation,
    ConfirmModal,
    ReviewItem,
    pdfContainer,
  },
  data: () => ({
    loadingComplete: false,
    loadingExit: false,
    showConfirmModal: false,
  }),
  computed: {
    canEdit() {
      const canEditFund = this.$store.getters['fund/canEditActiveFund'] || false;
      const appPermissions = this.$store.getters['account/getAppPermissions'] || [];
      const toolkitAppPermission = appPermissions.filter(
        app => app.appName === 'TOOLKIT',
      )[0];
      return toolkitAppPermission.permission === 'OWNER' && canEditFund;
    },
    isComplete() {
      return this.$store.getters['toolkit/getItem'].status === 'COMPLETE';
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    item() {
      return _.cloneDeep(this.$store.getters['toolkit/getItem']);
    },
    reviewItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    lastReview() {
      return this.reviewItem.lastReview;
    },
    review() {
      return this.reviewItem.review;
    },
    nextReview() {
      return this.reviewItem.nextReview;
    },
    reviewReasons() {
      return this.review.specific.reasons;
    },
    sectionReasons() {
      return Object.keys(this.review.specific.sectionReasons)
        .map((key) => {
          const reasons = this.review.specific.sectionReasons[key].selections;
          const otherIdx = reasons.findIndex(reason => reason === 'other');
          if (otherIdx > -1) {
            reasons.splice(
              otherIdx,
              1,
              this.review.specific.sectionReasons[key].other,
            );
          }
          return {
            label: key,
            options: reasons,
          };
        });
    },
    activeSelections() {
      return Object.keys(this.reviewReasons)
        // Filter the selected review reasons to only those sections that have valid selections
        .filter((section) => {
          const selections = Object.keys(this.reviewReasons[section]).filter((option) => {
            if (this.reviewReasons[section][option].selection instanceof Array) {
              return this.reviewReasons[section][option].selection.length > 0;
            }
            return this.reviewReasons[section][option].selection;
          });
          return selections.length > 0;
        })
        // Rework the object structure to use in this component
        .flatMap(section => ({
          label: section,
          options: Object.keys(this.reviewReasons[section])
            .filter((option) => {
              if (this.reviewReasons[section][option].selection instanceof Array) {
                return this.reviewReasons[section][option].selection.length > 0;
              }
              return this.reviewReasons[section][option].selection;
            })
            .flatMap((option) => {
              if (this.reviewReasons[section][option].selection instanceof Array) {
                const reasons = this.reviewReasons[section][option].selection;
                const otherIdx = reasons.findIndex(reason => reason === 'other');
                if (otherIdx > -1) {
                  reasons.splice(otherIdx, 1, this.reviewReasons[section][option].other);
                }
                return [option, ...reasons];
              }
              return option;
            }),
        }));
    },
  },
  methods: {
    saveItem(complete) {
      return this.$store.dispatch('toolkit/saveItem', complete);
    },
    handleSaveAndNew() {
      this.loadingComplete = true;
      this.showConfirmModal = false;
      this.saveItem(true)
        .then(() => {
          this.$mixpanel.track('Toolkit Item', {
            uuid: this.item.uuid,
            action: 'Completed',
            status: types(this.item.status),
            type: this.item.type,
          });

          if (this.canEdit) {
            this.$router.push('/toolkit/investment-strategy-review/dashboard');
          } else {
            this.$router.push('/');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveAndExit() {
      this.loadingExit = true;
      this.$mixpanel.track('Toolkit Item', {
        uuid: this.item.uuid,
        action: 'Exit',
        status: types(this.item.status),
        type: this.item.type,
      });
      if (this.canEdit) {
        this.$router.push('/toolkit/investment-strategy-review/dashboard');
      } else {
        this.$router.push('/');
      }
    },
  },
};
